<template>
  <div class="header header_cmp">
    <div class="header_name">
      <div class="logo_mark"></div>
      <h1 class="name">金创视频智慧监控大屏</h1>
    </div>

    <div class="header_center">
      <div class="ctrl_group">
        <div class="ctrl_item">
          <span class="ctrl_label">轮巡</span>
          <SwitchedSmall @change="switchLoopChange" :defaultChecked="isLoop" checkedInfo="ON" uncheckedInfo="OFF"
            :disabled="false"></SwitchedSmall>
        </div>
        <div class="ctrl_divider"></div>
        <div class="ctrl_item">
          <span class="ctrl_label">画面</span>
          <div class="ctrl_select" @click="toggleDropdown" ref="selectWrap">
            <span class="select_text">{{ pageSize }} 画面</span>
            <svg class="select_arrow" :class="{ open: dropdownOpen }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
            <transition name="dropdown">
              <div class="select_dropdown" v-if="dropdownOpen">
                <div class="select_option" :class="{ active: pageSize == '16' }" @click="selectPageSize('16')">16 画面</div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="header_actions">
      <div class="action_btn screen" @click="exitFullScreen" title="退出全屏">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
        </svg>
      </div>
      <div class="user_wrap" ref="userWrap">
        <div class="user_trigger" @click="toggleUserMenu">
          <img class="heading" src="@/assets/img/headimg.jpg" />
          <svg class="user_arrow" :class="{ open: userMenuOpen }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        <transition name="menu">
          <div class="user_menu" v-if="userMenuOpen">
            <div class="user_info">
              <img class="menu_avatar" src="@/assets/img/headimg.jpg" />
              <span class="menu_name">{{ user_info.user_nickname }}</span>
            </div>
            <div class="menu_divider"></div>
            <div class="menu_item logout" @click="loginOut">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span>退出登录</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchedSmall from './../Switched/SwitchedSmall';
export default {
  name: 'HeaderFullCmp',
  components: {
    SwitchedSmall
  },
  data() {
    return {
      dropdownOpen: false,
      userMenuOpen: false
    }
  },
  computed: {
    user_info() {
      return this.$store.state.user_info;
    },
    isLoop() {
      return this.$store.state.isLoop;
    },
    pageSize() {
      return this.$store.state.page_size;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocClick);
  },
  methods: {
    switchLoopChange(e) {
      this.$store.dispatch("doChangeLoop", e);
    },
    exitFullScreen() {
      this.$emit('onExitFull')
    },
    changeSelect(e) {
      this.$store.dispatch("doChangePageSize", e.target.value);
    },
    loginOut() {
      this.userMenuOpen = false;
      this.$store.dispatch("doLoginOut", this);
    },
    toggleDropdown(e) {
      e.stopPropagation();
      this.dropdownOpen = !this.dropdownOpen;
      this.userMenuOpen = false;
    },
    selectPageSize(size) {
      this.$store.dispatch("doChangePageSize", size);
      this.dropdownOpen = false;
    },
    toggleUserMenu(e) {
      e.stopPropagation();
      this.userMenuOpen = !this.userMenuOpen;
      this.dropdownOpen = false;
    },
    handleDocClick() {
      this.dropdownOpen = false;
      this.userMenuOpen = false;
    }
  }
}
</script>

<style scoped>
.header_cmp {
  width: 100%;
  height: 48px;
  background: rgba(11, 17, 32, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  position: relative;
  z-index: 10;
  flex-shrink: 0;
}

.header_cmp .header_name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header_cmp .logo_mark {
  width: 5px;
  height: 20px;
  background: linear-gradient(180deg, #3b82f6, #60a5fa);
  border-radius: 3px;
}

.header_cmp .header_name .name {
  color: #e2e8f0;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 中间控制区 */
.header_cmp .header_center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.header_cmp .ctrl_group {
  display: flex;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 3px 12px;
  height: 36px;
}

.header_cmp .ctrl_item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
}

.header_cmp .ctrl_label {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.header_cmp .ctrl_divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.08);
}

/* 自定义下拉 */
.header_cmp .ctrl_select {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 4px;
  transition: background 0.2s;
}

.header_cmp .ctrl_select:hover {
  background: rgba(255, 255, 255, 0.05);
}

.header_cmp .select_text {
  font-size: 12px;
  color: #e2e8f0;
  font-weight: 500;
  min-width: 42px;
  text-align: center;
}

.header_cmp .select_arrow {
  width: 12px;
  height: 12px;
  color: #64748b;
  transition: transform 0.3s;
}

.header_cmp .select_arrow.open {
  transform: rotate(180deg);
}

.header_cmp .select_dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(30, 41, 59, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 4px;
  min-width: 90px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  z-index: 200;
}

.header_cmp .select_option {
  padding: 7px 10px;
  font-size: 12px;
  color: #94a3b8;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s;
}

.header_cmp .select_option:hover,
.header_cmp .select_option.active {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s ease;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-6px);
}

/* 右侧操作区 */
.header_cmp .header_actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header_cmp .action_btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #94a3b8;
}

.header_cmp .action_btn:hover {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.3);
  color: #3b82f6;
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.2);
}

.header_cmp .action_btn svg {
  width: 15px;
  height: 15px;
}

/* 用户菜单 */
.header_cmp .user_wrap {
  position: relative;
}

.header_cmp .user_trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 5px 3px 3px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.header_cmp .user_trigger:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.12);
}

.header_cmp .user_trigger .heading {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.header_cmp .user_arrow {
  width: 12px;
  height: 12px;
  color: #64748b;
  transition: transform 0.3s;
}

.header_cmp .user_arrow.open {
  transform: rotate(180deg);
}

.header_cmp .user_menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 170px;
  background: rgba(30, 41, 59, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  z-index: 200;
}

.header_cmp .user_info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
}

.header_cmp .menu_avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.header_cmp .menu_name {
  font-size: 12px;
  color: #e2e8f0;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100px;
}

.header_cmp .menu_divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 3px 6px;
}

.header_cmp .menu_item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
  color: #94a3b8;
}

.header_cmp .menu_item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.header_cmp .menu_item.logout:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.header_cmp .menu_item svg {
  width: 14px;
  height: 14px;
}

.menu-enter-active,
.menu-leave-active {
  transition: all 0.2s ease;
}
.menu-enter,
.menu-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
